import { Box, Grid, Paper, Typography } from "@material-ui/core";
import Controls from "../../../../components/controls/Controls";
import FormBase from "../../../../forms/FormBase";
import AttachmentForm from "../../../../forms/medicoParceiro/AttachmentForm";
import FormFieldAttachmentBase, { FieldAttachment } from "../../../../forms/FormFieldAttachmentBase";



interface IMedicoParceiroAttachmentDataComponentProps {
    MedicoParceiroAttachmentForm: AttachmentForm,
    onInputChange: (name: string, form: FormBase, fieldAttachment: FieldAttachment, formField: FormFieldAttachmentBase) => void
    onDeleteFile: (name: string, form: FormBase, fieldAttachment: FieldAttachment, formField: FormFieldAttachmentBase) => void
}

export default function MedicoParceiroAttachmentDataComponent(props: IMedicoParceiroAttachmentDataComponentProps) {

    return (
        <div>
            <Grid container spacing={10}>

                <Grid item xs={6}>

                    <Grid container spacing={5}>
                        <Grid item xs={12}>
                            <Controls.Attachment label='Cópia da Carteira do Conselho Profissional *' name="CopiaCRM"
                                limitedFiles={props.MedicoParceiroAttachmentForm.CopiaCRM.LimitedFiles} typeFiles={'image/*, .pdf'}
                                values={props.MedicoParceiroAttachmentForm.CopiaCRM.Values}
                                error={props.MedicoParceiroAttachmentForm.CopiaCRM.Error}
                                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                                    props.onDeleteFile("CopiaCRM", props.MedicoParceiroAttachmentForm, fieldAttachment, props.MedicoParceiroAttachmentForm.CopiaCRM);
                                }}
                                onChange={(fieldAttachment: FieldAttachment) => {
                                    props.onInputChange("CopiaCRM", props.MedicoParceiroAttachmentForm, fieldAttachment, props.MedicoParceiroAttachmentForm.CopiaCRM);
                                }} />
                        </Grid>

                        <Grid item xs={12}>
                            <Controls.Attachment label='Cópia do Diploma de Graduação em Medicina *' name="CopiaDiplomaGraduacaoMedicina"
                                limitedFiles={props.MedicoParceiroAttachmentForm.CopiaDiplomaGraduacaoMedicina.LimitedFiles} typeFiles={'image/*, .pdf'}
                                values={props.MedicoParceiroAttachmentForm.CopiaDiplomaGraduacaoMedicina.Values}
                                error={props.MedicoParceiroAttachmentForm.CopiaDiplomaGraduacaoMedicina.Error}
                                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                                    props.onDeleteFile("CopiaDiplomaGraduacaoMedicina", props.MedicoParceiroAttachmentForm, fieldAttachment, props.MedicoParceiroAttachmentForm.CopiaDiplomaGraduacaoMedicina);
                                }}
                                onChange={(fieldAttachment: FieldAttachment) => {
                                    props.onInputChange("CopiaDiplomaGraduacaoMedicina", props.MedicoParceiroAttachmentForm, fieldAttachment, props.MedicoParceiroAttachmentForm.CopiaDiplomaGraduacaoMedicina);
                                }} />
                        </Grid>

                        <Grid item xs={12}>
                            <Controls.Attachment label='Cópia do RG *' name="CopiaRG"
                                limitedFiles={props.MedicoParceiroAttachmentForm.CopiaRG.LimitedFiles} typeFiles={'image/*, .pdf'}
                                values={props.MedicoParceiroAttachmentForm.CopiaRG.Values}
                                error={props.MedicoParceiroAttachmentForm.CopiaRG.Error}
                                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                                    props.onDeleteFile("CopiaRG", props.MedicoParceiroAttachmentForm, fieldAttachment, props.MedicoParceiroAttachmentForm.CopiaRG);
                                }}
                                onChange={(fieldAttachment: FieldAttachment) => {
                                    props.onInputChange("CopiaRG", props.MedicoParceiroAttachmentForm, fieldAttachment, props.MedicoParceiroAttachmentForm.CopiaRG);
                                }} />
                        </Grid>

                        <Grid item xs={12}>
                            <Controls.Attachment label='Certidão de Quitação *' name="CertidaoQuitacao"
                                limitedFiles={props.MedicoParceiroAttachmentForm.CertidaoQuitacao.LimitedFiles} typeFiles={'image/*, .pdf'}
                                values={props.MedicoParceiroAttachmentForm.CertidaoQuitacao.Values}
                                error={props.MedicoParceiroAttachmentForm.CertidaoQuitacao.Error}
                                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                                    props.onDeleteFile("CertidaoQuitacao", props.MedicoParceiroAttachmentForm, fieldAttachment, props.MedicoParceiroAttachmentForm.CertidaoQuitacao);
                                }}
                                onChange={(fieldAttachment: FieldAttachment) => {
                                    props.onInputChange("CertidaoQuitacao", props.MedicoParceiroAttachmentForm, fieldAttachment, props.MedicoParceiroAttachmentForm.CertidaoQuitacao);
                                }} />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={6}>
                    <Grid container spacing={5}>

                        <Grid item xs={12}>
                            <Controls.Attachment label='Certidão de Ética Profissional (emitida pelo site do CREMESP)*' name="CertidaoEticaProfissional"
                                limitedFiles={props.MedicoParceiroAttachmentForm.CertidaoEticaProfissional.LimitedFiles} typeFiles={'image/*, .pdf'}
                                values={props.MedicoParceiroAttachmentForm.CertidaoEticaProfissional.Values}
                                error={props.MedicoParceiroAttachmentForm.CertidaoEticaProfissional.Error}
                                onDeleteFile={(fieldAttachment : FieldAttachment) => {
                                    props.onDeleteFile("CertidaoEticaProfissional", props.MedicoParceiroAttachmentForm, fieldAttachment, props.MedicoParceiroAttachmentForm.CertidaoEticaProfissional);
                                }}
                                onChange={(fieldAttachment : FieldAttachment) => {
                                    props.onInputChange("CertidaoEticaProfissional", props.MedicoParceiroAttachmentForm, fieldAttachment, props.MedicoParceiroAttachmentForm.CertidaoEticaProfissional);
                                }} />
                        </Grid>

                        <Grid item xs={12}>
                            <Controls.Attachment label='Currículo Resumido Atualizado *' name="CurriculoResumidoAtualizado"
                                limitedFiles={props.MedicoParceiroAttachmentForm.CurriculoResumidoAtualizado.LimitedFiles} typeFiles={'image/*, .pdf'}
                                values={props.MedicoParceiroAttachmentForm.CurriculoResumidoAtualizado.Values}
                                error={props.MedicoParceiroAttachmentForm.CurriculoResumidoAtualizado.Error}
                                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                                    props.onDeleteFile("CurriculoResumidoAtualizado", props.MedicoParceiroAttachmentForm, fieldAttachment, props.MedicoParceiroAttachmentForm.CurriculoResumidoAtualizado);
                                }}
                                onChange={(fieldAttachment: FieldAttachment) => {
                                    props.onInputChange("CurriculoResumidoAtualizado", props.MedicoParceiroAttachmentForm, fieldAttachment, props.MedicoParceiroAttachmentForm.CurriculoResumidoAtualizado);
                                }} />
                        </Grid>

                        <Grid item xs={12}>
                            <Controls.Attachment label='Uma foto 3x4 fundo branco *' name="Foto"
                                limitedFiles={props.MedicoParceiroAttachmentForm.Foto.LimitedFiles} typeFiles={'image/*, .pdf'}
                                values={props.MedicoParceiroAttachmentForm.Foto.Values}
                                error={props.MedicoParceiroAttachmentForm.Foto.Error}
                                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                                    props.onDeleteFile("Foto", props.MedicoParceiroAttachmentForm, fieldAttachment, props.MedicoParceiroAttachmentForm.Foto);
                                }}
                                onChange={(fieldAttachment: FieldAttachment) => {
                                    props.onInputChange("Foto", props.MedicoParceiroAttachmentForm, fieldAttachment, props.MedicoParceiroAttachmentForm.Foto);
                                }} />
                        </Grid>

                        <Grid item xs={12}>
                            <Controls.Attachment label='Comprovante de Vacinação COVID19' name="ComprovanteVacinaCovid"
                                limitedFiles={props.MedicoParceiroAttachmentForm.ComprovanteVacinaCovid.LimitedFiles} typeFiles={'image/*, .pdf'}
                                values={props.MedicoParceiroAttachmentForm.ComprovanteVacinaCovid.Values}
                                error={props.MedicoParceiroAttachmentForm.ComprovanteVacinaCovid.Error}
                                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                                    props.onDeleteFile("ComprovanteVacinaCovid", props.MedicoParceiroAttachmentForm, fieldAttachment, props.MedicoParceiroAttachmentForm.ComprovanteVacinaCovid);
                                }}
                                onChange={(fieldAttachment: FieldAttachment) => {
                                    props.onInputChange("ComprovanteVacinaCovid", props.MedicoParceiroAttachmentForm, fieldAttachment, props.MedicoParceiroAttachmentForm.ComprovanteVacinaCovid);
                                }} />
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>

            <br />
            <br />

            <Paper variant="outlined" >
                <Box p={1}>

                    <Typography variant="subtitle1" gutterBottom component="div">
                        Cópia do Título de Especialista ou Residência Médica *
                    </Typography>

                    <Grid container spacing={10}>

                        <Grid item xs={6}>

                            <Grid container spacing={5}>
                                <Grid item xs={12}>
                                    <Controls.Attachment label='Título de Especialista' name="CopiaTituloEspecialista"
                                        limitedFiles={props.MedicoParceiroAttachmentForm.CopiaTituloEspecialista.LimitedFiles} typeFiles={'image/*, .pdf'}
                                        values={props.MedicoParceiroAttachmentForm.CopiaTituloEspecialista.Values}
                                        error={props.MedicoParceiroAttachmentForm.CopiaTituloEspecialista.Error}
                                        onDeleteFile={(fieldAttachment: FieldAttachment) => {
                                            props.onDeleteFile("CopiaTituloEspecialista", props.MedicoParceiroAttachmentForm, fieldAttachment, props.MedicoParceiroAttachmentForm.CopiaTituloEspecialista);
                                        }}
                                        onChange={(fieldAttachment: FieldAttachment) => {
                                            props.onInputChange("CopiaTituloEspecialista", props.MedicoParceiroAttachmentForm, fieldAttachment, props.MedicoParceiroAttachmentForm.CopiaTituloEspecialista);
                                        }} />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={6}>
                            <Grid container spacing={5}>
                                <Grid item xs={12}>
                                    <Controls.Attachment label='Residência Médica' name="CopiaResidenciaMedica"
                                        limitedFiles={props.MedicoParceiroAttachmentForm.CopiaResidenciaMedica.LimitedFiles} typeFiles={'image/*, .pdf'}
                                        values={props.MedicoParceiroAttachmentForm.CopiaResidenciaMedica.Values}
                                        error={props.MedicoParceiroAttachmentForm.CopiaResidenciaMedica.Error}
                                        onDeleteFile={(fieldAttachment: FieldAttachment) => {
                                            props.onDeleteFile("CopiaResidenciaMedica", props.MedicoParceiroAttachmentForm, fieldAttachment, props.MedicoParceiroAttachmentForm.CopiaResidenciaMedica);
                                        }}
                                        onChange={(fieldAttachment: FieldAttachment) => {
                                            props.onInputChange("CopiaResidenciaMedica", props.MedicoParceiroAttachmentForm, fieldAttachment, props.MedicoParceiroAttachmentForm.CopiaResidenciaMedica);
                                        }} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <br />
                    <Typography variant="caption" display="block" gutterBottom>
                        Obs.: Pode ser anexado um arquivo.
                    </Typography>
                </Box>
            </Paper>

            <br />
            <br />

        </div >
    );
}